module.exports = __webpack_public_path__ + "img/Pic-3.242d66ae.png";